export const SFDT_COMMENT_TIMEZONE_OFFSET_MINUTES_KEY =
  'evisortCommentTimezoneOffsetMinutes';

export const stampSfdtCommentTimezoneOffset = (
  sfdt: Record<string, unknown>,
) => {
  sfdt[SFDT_COMMENT_TIMEZONE_OFFSET_MINUTES_KEY] =
    new Date().getTimezoneOffset();
  return sfdt;
};

export const stampSfdtFileCommentTimezoneOffset = async (file: File) => {
  const sfdt = JSON.parse(await file.text()) as Record<string, unknown>;
  stampSfdtCommentTimezoneOffset(sfdt);
  return new File([JSON.stringify(sfdt)], file.name, {
    type: file.type || 'application/json',
  });
};
